"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965-4.9991-5.0006h-.686v-.6862L13 15.8143v2.1858H3v-3h9.186L1 3.8106l1.3979-1.3965zm13.9094 11.0849-1.5414-1.5418c.0996-.5559.1129-1.1064-.1013-1.6802l-.5275-1.413a5 5 0 0 1-.1745-2.9291l.216-.9308h2.0581l-.3306 1.4029a2.9994 2.9994 0 0 0 .1047 1.7575l.5275 1.413a5.0001 5.0001 0 0 1 .1527 3.0153c-.0772.2948-.1937.5982-.1937.9062h-.19zm1.6923 1.6929 2 2.0006v-2.1918h-2v.1912zm-.0023-1.6929h2c0-.3161.1144-.6229.1937-.9258a5 5 0 0 0-.1527-3.0153l-.5275-1.413a2.9995 2.9995 0 0 1-.1047-1.7574l.3259-1.3834h-2.0582l-.2112.9112a5 5 0 0 0 .1745 2.9291l.5275 1.4131c.3091.8279.1445 1.6071-.0695 2.4244-.0701.2678-.0978.5409-.0978.8171z"
  })];
};

exports.default = _default;